import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { Platform, View } from 'react-native';
import { VibrancyView, BlurView as BlurViewBase,
// @ts-expect-error ---
 } from '@react-native-community/blur';
const AndroidBlurView = React.memo(function AndroidBlurView(props) {
    return (_jsx(View
    // eslint-disable-next-line react-native/no-inline-styles
    , { 
        // eslint-disable-next-line react-native/no-inline-styles
        style: {
            ...(props.style ?? {}),
            overflow: 'hidden',
        }, children: _jsx(BlurViewBase, { ...props, style: props.innerStyle ?? {} }) }));
});
export const BlurView = Platform.OS === 'ios' ? VibrancyView : AndroidBlurView;
